import React from "react";
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from "react-icons/fi";

const DeleteGroupTrainingModal = ({ isOpen, onClose, onConfirm, itemName, isLoading }) => {
    const { t } = useTranslation(['groups', 'common']);

    if (!isOpen) return null;

    return (
        <div className="modern-modal-overlay">
            <div className="modern-modal confirmation-modal">
                <div className="modern-modal-header">
                    <h2 className="modern-modal-title">{t('confirmDelete')}</h2>
                    <button
                        className="modern-close-btn"
                        onClick={onClose}
                    >
                        &times;
                    </button>
                </div>

                <div className="modern-modal-content">
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                        <FiAlertTriangle size={24} color="#ef4444" style={{ marginRight: "0.75rem" }} />
                        <strong>{t('confirmDeleteItem', { itemName })}</strong>
                    </div>
                    <p className="confirmation-message">
                        {t('deleteIrreversibleWithData')}
                    </p>
                    <p className="warning-message">
                        {t('deleteGroupTrainingsWarning')}
                    </p>
                </div>

                <div className="modern-modal-footer">
                    <button
                        className="modern-cancel-button"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        {t('common:cancel')}
                    </button>
                    <button
                        className="modern-delete-btn"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? t('deleting') : t('common:delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteGroupTrainingModal;
